// import axiosClient from "./AxiosClient";
// import { API_BASE_URL } from "../config";
// import { DAYS_IN_MS, RECENT_CHAT_DAYS, OLDER_CHAT_DAYS } from "../utils/constants";

// type GetSessionsPayload = {
//   user_id: string;
//   project_id: string;
//   offset?: number;
//   limit?: number;
//   start_date: string; // YYYY-MM-DD format
//   end_date: string; // YYYY-MM-DD format
// };

// const ChatHistoryApi = {
//   // Projects API
//   getAllProjects: async (accessToken?: string) => {
//     const url = `${API_BASE_URL.replace(/\/$/, "")}/projects/get_all_projects`;
//     return axiosClient.post(url, {});
//   },

//   // New session-based API
//   getSessions: async (
//     payload: GetSessionsPayload,
//     options?: { accessToken?: string }
//   ) => {
//     const url = `${API_BASE_URL.replace(/\/$/, "")}/session/get_sessions`;
//     return axiosClient.post(url, payload);
//   },

//   /**
//    * Fetch sessions for a given user/project and date range with pagination.
//    * @param userId string
//    * @param projectId string
//    * @param days number (number of days back from today)
//    * @param offset number (pagination offset, default 0)
//    * @param accessToken string | undefined
//    */
//   getSessionsByDays: async (
//     userId: string,
//     projectId: string,
//     days: number,
//     accessToken?: string,
//     offset: number = 0,
//     limit: number = 50
//   ) => {
//     const endDate = new Date(Date.now() + DAYS_IN_MS).toISOString().split("T")[0];
//     const startDate = new Date(Date.now() - days * DAYS_IN_MS).toISOString().split("T")[0];
//     return ChatHistoryApi.getSessions(
//       {
//         user_id: userId,
//         project_id: projectId,
//         start_date: startDate,
//         end_date: endDate,
//         offset,
//         limit,
//       },
//       { accessToken }
//     );
//   },

//   // Delete session API
//   deleteSession: async (sessionId: string, accessToken?: string) => {
//     const url = `${API_BASE_URL.replace(/\/$/, "")}/session/delete`;
//     return axiosClient.post(url, { session_id: sessionId });
//   },

//   // Get messages for a session
//   getMessages: async (sessionId: string, accessToken?: string) => {
//     const url = `${API_BASE_URL.replace(/\/$/, "")}/messages/get_messages`;
//     return axiosClient.post(url, { session_id: sessionId });
//   },

//   // Rename session API
//   updateSession: async (sessionId: string, name: string, accessToken?: string) => {
//     const url = `${API_BASE_URL.replace(/\/$/, "")}/session/update`;
//     return axiosClient.post(url, { session_id: sessionId, name });
//   },


// };

// export type { GetSessionsPayload };
// export default ChatHistoryApi;

import axiosClient from "./AxiosClient";
import { API_BASE_URL } from "../config";
import { DAYS_IN_MS, RECENT_CHAT_DAYS, OLDER_CHAT_DAYS } from "../utils/constants";

type GetSessionsPayload = {
  user_id: string;
  project_id: string;
  offset?: number;
  limit?: number;
  start_date: string; // YYYY-MM-DD format
  end_date: string; // YYYY-MM-DD format
};

const ChatHistoryApi = {
  // Projects API
  getAllProjects: async (accessToken?: string) => {
    const url = `${API_BASE_URL.replace(/\/$/, "")}/projects/get_all_projects`;
    return axiosClient.post(url, {});
  },

  // New session-based API
  getSessions: async (
    payload: GetSessionsPayload,
    options?: { accessToken?: string }
  ) => {
    const url = `${API_BASE_URL.replace(/\/$/, "")}/session/get_sessions`;
    return axiosClient.post(url, payload);
  },

  /**
   * Fetch sessions for a given user/project and date range.
   * @param userId string
   * @param projectId string
   * @param days number (number of days back from today)
   * @param accessToken string | undefined
   * @param offset number (pagination offset, default 0)
   * @param limit number (number of records to fetch, default 50)
   */
  getSessionsByDays: async (
    userId: string,
    projectId: string,
    days: number,
    accessToken?: string,
    offset: number = 0,
    limit: number = 50
  ) => {
    const endDate = new Date(Date.now() + DAYS_IN_MS).toISOString().split("T")[0];
    const startDate = new Date(Date.now() - days * DAYS_IN_MS).toISOString().split("T")[0];
    return ChatHistoryApi.getSessions(
      { user_id: userId, project_id: projectId, start_date: startDate, end_date: endDate, offset, limit },
      { accessToken }
    );
  },

  // Delete session API
  deleteSession: async (sessionId: string, accessToken?: string) => {
    const url = `${API_BASE_URL.replace(/\/$/, "")}/session/delete`;
    return axiosClient.post(url, { session_id: sessionId });
  },

  // Get messages for a session
  getMessages: async (sessionId: string, accessToken?: string) => {
    const url = `${API_BASE_URL.replace(/\/$/, "")}/messages/get_messages`;
    return axiosClient.post(url, { session_id: sessionId });
  },

  // Rename session API
  updateSession: async (sessionId: string, name: string, accessToken?: string) => {
    const url = `${API_BASE_URL.replace(/\/$/, "")}/session/update`;
    return axiosClient.post(url, { session_id: sessionId, name });
  },


};

export type { GetSessionsPayload };
export default ChatHistoryApi;
